/* =========================================================================
   MODENARO — shared theme behaviour
   Live cart uses the Shopify Cart AJAX API (/cart/*.js) + Section Rendering API.
   ========================================================================= */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Money formatting (Shopify standard) — driven by shop.money_format
     injected as window.theme.moneyFormat in layout/theme.liquid.
     --------------------------------------------------------------------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  // Mirror Liquid's `money_without_trailing_zeros`: drop a .00 / ,00 ending.
  function money(cents) { return formatMoney(cents).replace(/([.,])00(?!\d)/, ''); }

  /* ---------------------------------------------------------------------
     Sticky header: transparent over hero, solid on scroll
     --------------------------------------------------------------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var transparentStart = header.hasAttribute('data-transparent');
    var onScroll = function () {
      var solid = window.scrollY > 24;
      header.classList.toggle('is-solid', solid || !transparentStart);
      header.classList.toggle('is-transparent', transparentStart && !solid);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------------------------------------------------------------
     Cart drawer — open/close (re-query each time so it survives re-renders)
     --------------------------------------------------------------------- */
  var cartOpen = false;
  function setDrawer(open) {
    var drawer = document.querySelector('[data-cart-drawer]');
    var scrim = document.querySelector('[data-scrim]');
    cartOpen = !!(open && drawer);
    if (drawer) drawer.classList.toggle('is-open', cartOpen);
    if (scrim) scrim.classList.toggle('is-open', cartOpen);
    document.body.style.overflow = cartOpen ? 'hidden' : '';
  }

  /* ---------------------------------------------------------------------
     Section Rendering API helpers
     --------------------------------------------------------------------- */
  function cartSectionIds() {
    var ids = [];
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) { var dw = drawer.closest('.shopify-section'); if (dw) ids.push(dw.id.replace('shopify-section-', '')); }
    var page = document.querySelector('[data-cart-page]');
    if (page) { var pw = page.closest('.shopify-section'); if (pw) ids.push(pw.id.replace('shopify-section-', '')); }
    return ids;
  }
  function renderSection(id, html) {
    var live = document.getElementById('shopify-section-' + id);
    if (!live || html == null) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-' + id);
    live.innerHTML = fresh ? fresh.innerHTML : html;
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) { renderSection(id, sections[id]); });
  }
  // After a mutation, propagate the authoritative item count to every badge.
  function syncCount() {
    var fromDrawer = document.querySelector('[data-cart-drawer] [data-cart-count]');
    if (fromDrawer) {
      var n = fromDrawer.textContent.trim();
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    } else {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        }).catch(function () {});
    }
  }

  /* ---------------------------------------------------------------------
     Cart mutations — change qty / remove via /cart/change.js
     --------------------------------------------------------------------- */
  function changeCart(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: cartSectionIds().join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applySections(cart.sections); syncCount(); setDrawer(cartOpen); })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------------
     Global click delegation — works across re-rendered cart markup
     --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    // Open drawer (only intercept when a drawer exists; else follow link to /cart)
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && document.querySelector('[data-cart-drawer]')) { e.preventDefault(); setDrawer(true); return; }
    if (e.target.closest('[data-cart-close]')) { setDrawer(false); return; }
    if (e.target.closest('[data-scrim]')) { setDrawer(false); return; }

    // Quantity steppers / remove
    var inc = e.target.closest('[data-inc]');
    var dec = e.target.closest('[data-dec]');
    var rem = e.target.closest('[data-remove]');
    if (inc || dec || rem) {
      var row = e.target.closest('[data-citem]');
      if (!row) return;
      var key = row.getAttribute('data-key');
      if (!key) return;
      var span = row.querySelector('[data-qty]');
      var qty = parseInt(span && span.textContent, 10) || 1;
      var next = rem ? 0 : inc ? qty + 1 : Math.max(1, qty - 1);
      if (next === qty && !rem) return; // dec at 1 → no-op
      changeCart(key, next);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* ---------------------------------------------------------------------
     Add to cart (PDP) — /cart/add.js, then open the refreshed drawer
     --------------------------------------------------------------------- */
  var pform = document.getElementById('product-form');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var atc = pform.querySelector('[data-add-to-cart]');
      var sel = pform.querySelector('select[name="id"]');
      var id = (sel && sel.value) || (atc && atc.getAttribute('data-variant-id'));
      if (!id) return;
      if (atc) { atc.classList.add('is-loading'); atc.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: cartSectionIds().join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (atc) { atc.classList.remove('is-loading'); atc.disabled = false; }
          if (res.status) { return; } // 422 etc. — leave button as-is
          applySections(res.sections);
          syncCount();
          setDrawer(true);
        })
        .catch(function () { if (atc) { atc.classList.remove('is-loading'); atc.disabled = false; } });
    });
  }

  /* ---------------------------------------------------------------------
     Variant selection (PDP) — map chosen options → variant id, price,
     availability, URL, and featured image.
     --------------------------------------------------------------------- */
  (function () {
    var form = document.getElementById('product-form');
    var json = document.querySelector('[data-product-json]');
    if (!form || !json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }
    var groups = form.querySelectorAll('[data-variant-group]');
    if (!groups.length) return;

    function selectedOptions() {
      var opts = [];
      groups.forEach(function (g, i) {
        var pos = parseInt(g.getAttribute('data-option-position'), 10) || (i + 1);
        var active = g.querySelector('[data-variant].is-active');
        opts[pos - 1] = active ? active.getAttribute('data-value') : null;
      });
      return opts;
    }
    function match(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function update() {
      var v = match(selectedOptions());
      var sel = form.querySelector('select[name="id"]');
      var atc = form.querySelector('[data-add-to-cart]');
      if (v) {
        if (sel) sel.value = v.id;
        document.querySelectorAll('[data-variant-price]').forEach(function (el) { el.textContent = money(v.price); });
        if (atc) {
          atc.setAttribute('data-variant-id', v.id);
          atc.disabled = !v.available;
          atc.textContent = v.available ? ('Add to Cart · ' + money(v.price)) : 'Sold Out';
        }
        var img = document.querySelector('[data-gallery-main-img]');
        if (img && v.featured_image && v.featured_image.src) { img.src = v.featured_image.src; }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (err) {}
      } else if (atc) {
        atc.disabled = true;
        atc.textContent = 'Unavailable';
      }
    }

    groups.forEach(function (g) {
      g.querySelectorAll('[data-variant]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          g.querySelectorAll('[data-variant]').forEach(function (x) { x.classList.remove('is-active'); });
          opt.classList.add('is-active');
          var label = g.querySelector('[data-variant-label]');
          if (label) label.textContent = opt.getAttribute('data-name');
          update();
        });
      });
    });
    update();
  })();

  /* ---------------------------------------------------------------------
     Mobile menu
     --------------------------------------------------------------------- */
  var mtoggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (mtoggle && mobileMenu) {
    mtoggle.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a,[data-menu-close]').forEach(function (a) {
      a.addEventListener('click', function () { mobileMenu.classList.remove('is-open'); document.body.style.overflow = ''; });
    });
  }

  /* ---------------------------------------------------------------------
     Localization (currency / language) — submit on change
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-localization]').forEach(function (sel) {
    sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); });
  });

  /* ---------------------------------------------------------------------
     PDP gallery thumbnails — swap the main image
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var mainImg = g.querySelector('[data-gallery-main-img]');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-media-src');
        if (mainImg && src) {
          mainImg.src = src;
        } else {
          var label = t.getAttribute('data-label');
          var l = g.querySelector('[data-gallery-main] .ph__label');
          if (l && label) l.textContent = label;
        }
      });
    });
  });

  /* ---------------------------------------------------------------------
     PDP accordions
     --------------------------------------------------------------------- */
  document.querySelectorAll('[data-acc]').forEach(function (acc) {
    var head = acc.querySelector('[data-acc-head]');
    if (head) head.addEventListener('click', function () { acc.classList.toggle('is-open'); });
  });

  /* ---------------------------------------------------------------------
     Reveal on scroll
     --------------------------------------------------------------------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
})();
